import {
  Column,
  CreateDateColumn,
  DeleteDateColumn,
  Entity,
  ManyToOne,
  OneToMany,
  PrimaryGeneratedColumn
} from 'typeorm';
import { COMANDA_ABERTA } from '../constants';
import Cliente from './Cliente';
import Pedido from './Pedido';

@Entity()
export class Comanda {
  @PrimaryGeneratedColumn()
  id!: number;

  // @Column()
  // numeroMesa: number = 0;

  @Column()
  nome: string = '';

  @Column()
  status: string = COMANDA_ABERTA;

  @OneToMany(() => Pedido, (produto: Pedido) => produto.comanda)
  pedidos!: Pedido[];

  @ManyToOne(() => Cliente, { eager: true })
  cliente?: Cliente;

  @CreateDateColumn()
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;
}

export default Comanda;
